"use client";

import type { ReactNode } from "react";
import { InfoTip } from "@/shared/components/info-tip/info-tip";

interface FieldTooltipProps {
  term: string;
  content: string;
  example?: string;
}

/// Form-field flavour of `InfoTip`. Keeps its own prop names (`content`
/// rather than `definition`) because five Field primitives and two review
/// components pass them; renaming would churn every call site for nothing
/// a user can see. The bubble itself is `InfoTip`, so form help and the
/// help on Insights are the same component.
export function FieldTooltip({ term, content, example }: FieldTooltipProps): ReactNode {
  return (
    <InfoTip
      term={term}
      definition={content}
      example={example ? `Example: ${example}` : undefined}
    />
  );
}
